import { PoStorageService } from '@po-ui/ng-storage';

export interface IFiltroControleQualidadeLista {
  lastSetDefault: Date;

  DZ04DATA_DE: Date | undefined;
  DZ04DATA_ATE: Date | undefined;
  CZ04LOTE: string;
  CZ04STATUS: string;
  CAPENASUSUARIO: string;
}

export class FiltroControleQualidadeLista {

  dados: IFiltroControleQualidadeLista;
  storageName: string;

  constructor(private poStorageService: PoStorageService) {

    this.dados = this.setDefault();
    this.storageName = 'interface-filtro-lista-controle-qualidade';

    this.poStorageService.get(this.storageName).then((filtro: IFiltroControleQualidadeLista) => {
      if (filtro) {

        const {
          lastSetDefault,
          DZ04DATA_DE,
          DZ04DATA_ATE
        } = filtro;

        if (!lastSetDefault && (new Date().getDay() - new Date(lastSetDefault).getDay())) {
          this.dados = this.setDefault();
        } else {
          this.dados = {
            ...filtro,
            lastSetDefault: new Date(lastSetDefault),
            DZ04DATA_DE: DZ04DATA_DE ? new Date(DZ04DATA_DE) : undefined,
            DZ04DATA_ATE: DZ04DATA_ATE ? new Date(DZ04DATA_ATE) : undefined,
          };
        }
      }
    });
  }

  public setDefault = (): IFiltroControleQualidadeLista => {
    return {
      lastSetDefault: new Date(),
      DZ04DATA_DE: this.getData(-7),
      DZ04DATA_ATE: new Date(),
      CZ04LOTE: '',
      CZ04STATUS: '',
      CAPENASUSUARIO: 'N',
    };
  }

  public setStorage = (): void => {
    this.poStorageService.set(this.storageName, this.dados);
  }

  private getData = (dias: number): Date => {
    const dataDe = new Date();
    dataDe.setDate(dataDe.getDate() + dias);
    return dataDe;
  }

}
